import { range } from '../range';
import removeItem from './removeItem';
import { addMultipleItems } from './addMultipleItems';
import { updateMultipleItems } from './updateMultipleItems';

export default function updateDependentItems(model, options = {}) {
  const diff = range.getDependencyDiff(model, options);

  if (diff) {
    const { added, updated, removed } = diff;

    if (removed.length) {
      if (!options.isPersistent) {
        removed
          .filter(item => !item.keepDuringDrag)
          .forEach(item => {
            model = removeItem(model, item);
          });
        model = updateMultipleItems(
          model,
          removed.filter(item => item.keepDuringDrag),
          model,
          { ...options, moveOthers: false }
        );
      } else {
        removed.forEach(item => {
          model = removeItem(model, item);
        });
      }
    }

    if (updated.length) {
      if (options.flagTempItems) {
        updated.forEach(item => (item.isTempItem = true));
      }
      model = updateMultipleItems(model, updated, model, {
        ...options,
        moveOthers: false,
      });
    }

    if (added.length) {
      if (options.flagTempItems) {
        added.forEach(item => (item.isTempItem = true));
      }
      model = addMultipleItems(model, added, model, options);
    }
  }

  return model;
}
